var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTurkeyFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_603_8866)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 150,
    fill: "#E30A17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.994 150.5L255 127.431L211.113 187.829V113.171L255 173.569L183.994 150.5ZM188.835 192.477C179.74 206.849 166.224 217.878 150.319 223.905C134.415 229.933 116.984 230.632 100.648 225.897C84.3125 221.163 69.9564 211.251 59.7401 197.653C49.5238 184.056 44 167.508 44 150.5C44 133.492 49.5238 116.944 59.7401 103.347C69.9564 89.7491 84.3125 79.8373 100.648 75.1028C116.984 70.3683 134.415 71.0673 150.319 77.0946C166.224 83.1219 179.74 94.1514 188.835 108.523C180.342 99.0729 169.182 92.4208 156.829 89.4458C144.476 86.4707 131.512 87.3126 119.647 91.8604C107.783 96.4081 97.5772 104.448 90.3779 114.917C83.1786 125.387 79.3244 137.794 79.3244 150.5C79.3244 163.206 83.1786 175.613 90.3779 186.083C97.5772 196.552 107.783 204.592 119.647 209.14C131.512 213.687 144.476 214.529 156.829 211.554C169.182 208.579 180.342 201.927 188.835 192.477Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_603_8866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkeyFlag);
export default __webpack_public_path__ + "static/media/turkey-flag.c3e5ec9322c02b842f7d58fe99336aa9.svg";
export { ForwardRef as ReactComponent };